import React, { useEffect } from "react"
import { Headline } from "../../../../components/parts/headline/headline"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUsers } from "@fortawesome/free-solid-svg-icons/faUsers"
import { Loading } from "../../../../components/parts/loading"
import { Wrapper } from "../../../../components/templates/wrapper"
import { JSONRPCErrorCatch } from "../../../../error/error"
import { JSONRPCClientBuilder } from "../../../../request/JSONRPCClientBuilder"
import { ChannelRPC } from "../../../../rpcs/dist/ChannelRPC"
import Width from "../../../../style/enum/width"
import { BackButton } from "../../../../components/parts/buttons/back-button"
import { RouteComponentProps } from "react-router"
import { container, IChannelContainerProps } from "../../container"
import { List } from "./components/list"

type IProps = IChannelContainerProps &
  RouteComponentProps<{
    name: string
  }>

const Component = (props: IProps) => {
  // フォロワー情報取得にチャンネルIDが必要なので、チャンネルIDが取得できなければチャンネルID取得の為
  // チャンネルプロフィールを取得する
  useEffect(() => {
    ;(async () => {
      const channelRPC = JSONRPCClientBuilder.build(ChannelRPC)
      if (!props.channel.profile) {
        const res = await channelRPC
          .profile({
            channelName: props.match.params.name,
          })
          .catch(JSONRPCErrorCatch)
        if (res !== -1) {
          props.actions.fetchChannelProfile(res)
        }
      }
    })()
    return () => props.actions.reset()
    // eslint-disable-next-line
  }, [props.match.params.name])

  if (props.channel.profile === null) {
    return <Loading />
  }

  return (
    <Wrapper maxWidth={Width.EPISODE_LIST}>
      <BackButton to={`/channel/${props.match.params.name}`} />
      <Headline>
        <FontAwesomeIcon icon={faUsers} /> チャンネルフォロワー
      </Headline>
      <List
        followers={props.channel.followers}
        actions={props.actions}
        channelId={props.channel.profile.id}
      />
    </Wrapper>
  )
}

export default container(Component)
